import PropTypes from 'prop-types';
import { Outlet, useRouteLoaderData } from 'react-router-dom';
import { UrqlRender } from '../../shared/storybookRender';
import RootLayout from '../RootLayout';
import ListOfCategoriesWithDeals from '../ListOfCategoriesWithDeals';
import ComponentWrapper from '../ComponentWrapper/ComponentWrapper';

const UrqlWrapper = ({ children }) => {
	const { apiEnvironment, ssId, hpCode } = useRouteLoaderData(
		'healthyDealsRoutesData',
	);

	return (
		<UrqlRender apiEnvironment={apiEnvironment} ssId={ssId} hpCode={hpCode}>
			{children}
		</UrqlRender>
	);
};

UrqlWrapper.propTypes = {
	children: PropTypes.node.isRequired,
};

const ConditionalWrap = ({ children }) => {
	const { hasOwnProvider } = useRouteLoaderData('healthyDealsRoutesData');
	return !hasOwnProvider ? <UrqlWrapper>{children}</UrqlWrapper> : { children };
};

ConditionalWrap.propTypes = {
	children: PropTypes.node.isRequired,
};

const healthyDealsRoutes = [
	{
		path: '',
		element: (
			<ConditionalWrap>
				<ComponentWrapper>
					<Outlet />
				</ComponentWrapper>
			</ConditionalWrap>
		),
		children: [
			{
				path: '',
				element: <RootLayout />,
				children: [
					{
						index: true,
						element: <ListOfCategoriesWithDeals />,
					},
				],
			},
			{
				path: ':dealType/:dealId',
				async lazy() {
					const { default: Deal } = await import('../Deal');
					return {
						Component: Deal,
					};
				},
			},
		],
	},
];

export default healthyDealsRoutes;
